<template>
  <a-form-model
    ref="addReportForm"
    :form="form"
    :model="form"
    @submit="handleSubmit"
    @submit.native.prevent
  >
    <div class="w-full flex">
      <a-form-model-item label="Year" prop="year" class="mr-4 flex-1">
        <a-select v-model="form.year">
          <a-select-option v-for="year in years" :key="year" :value="year">
            {{ year }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="Month" prop="month" class="flex-1">
        <a-select v-model="form.month">
          <a-select-option
            v-for="month in months"
            :key="month.value"
            :value="month.value"
          >
            {{ month.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </div>
    <div class="w-full flex">
      <a-form-model-item
        :label="'Share value (' + institution.currency + ')'"
        class="mr-4 flex-1"
        prop="shareValue"
      >
        <a-input-number v-model="form.shareValue" class="w-full" />
      </a-form-model-item>
      <a-form-model-item
        :label="'Dividend (' + institution.currency + ')'"
        class="flex-1"
        prop="dividend"
      >
        <a-input-number v-model="form.dividend" class="w-full" />
      </a-form-model-item>
    </div>

    <a-button type="primary" html-type="submit" :disabled="isSaving">
      Save
    </a-button>
    <a-button class="ml-4" @click="onCancelButtonClicked()">
      Cancel
    </a-button>
  </a-form-model>
</template>

<script>
import gql from 'graphql-tag'
import months from '../../data/Months'

export default {
  props: {
    institution: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        shareValue: null,
        dividend: null,
      },
      months,
      isSaving: false,
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
    years() {
      let year = 2003
      let result = []
      while (year <= this.currentYear) {
        result.push(year)
        year++
      }
      return result
    },
  },
  methods: {
    handleSubmit() {
      this.$refs.addReportForm.validate(async (valid) => {
        if (valid) {
          try {
            this.isSaving = true
            await this.$apollo.mutate({
              mutation: gql`
                mutation($input: AddFIMonthlyReportInput) {
                  addFIMonthlyReport(input: $input) {
                    reportId
                  }
                }
              `,
              variables: {
                input: {
                  institutionId: this.institution.id,
                  institutionName: this.institution.name,
                  institutionIsin: this.institution.isin,
                  currency: this.institution.currency,
                  year: this.form.year,
                  month: this.form.month,
                  shareValue: this.form.shareValue,
                  dividend: this.form.dividend,
                },
              },
            })
            this.isSaving = false
            this.$refs.addReportForm.resetFields()
            this.$emit('reportSaved', {
              year: this.form.year,
              month: this.form.month,
            })
          } catch (error) {
            this.$message.error(error.message)
            this.isSaving = false
          }
        } else {
          return false
        }
      })
    },
    onCancelButtonClicked() {
      this.$emit('cancelButtonClicked')
      this.$refs.addReportForm.resetFields()
    },
  },
}
</script>

<style></style>
